// extracted by mini-css-extract-plugin
module.exports = {"back":"ConnectToWallet_back__D01o0","header":"ConnectToWallet_header__1hXli","titleModal":"ConnectToWallet_titleModal__3gDnn","closeIcon":"ConnectToWallet_closeIcon__1Ojrm"};